import { Box } from '@ouster/webviz-react-components';

export default function OrganizationMerge() {
  return (
    <Box
      display="flex"
      placeItems="center"
      justifyContent="center"
      h="full"
      fontSize="2xl"
    >
      Organization merge (coming soon...)
    </Box>
  );
}
